import React, { useEffect } from "react";
import "./PublicOrder.scss";
import ItemContainer from "../../modules/order/containers/Item";
import withPage from "./withPage";
import { getTranslation } from "../../utils/helper";
import { DATETIME_FORMAT_FRONTEND, DATE_FORMAT_FRONTEND, STATUS } from "../../constants";
import moment from "moment";
import { Col, Row, Spin } from "antd";

const PublicOrder = ({ orderCode, order, doDetailPublicOrder }) => {
  useEffect(() => {
    if (orderCode) {
      doDetailPublicOrder(orderCode);
    }
  }, [orderCode]);

  if (!order) return <Spin style={{ paddingTop: 100, width: "100%" }} />;

  const company = order.company;

  const logs = order?.logs || [];
  console.log(logs);
  const labels = order?.labels || [];
  const statusDatetime = status => logs.find(l => l.status === status)?.createdAt;
  const status = order?.status?.toLowerCase();

  return (
    <div className="order-detail">
      <header className="order-logo">
        <div className="logo">
          <img src={company.logo} alt="Parcelizer Logo" />
        </div>
      </header>
      <div className="order-info">
        <div className="order-info-header">
          <div className="order-id">
            <p>PID239833-260920-01</p>
          </div>
          <div className="order-status-info">
            <div className="Info">
              <span className={"status orderStatus " + status}>
                {getTranslation({}, "Orders", STATUS.find(s => s.code === order.status)?.name)}
              </span>
            </div>
            <p className="date">
              {statusDatetime(order.status)
                ? moment(statusDatetime(order.status)).format(DATETIME_FORMAT_FRONTEND)
                : "-"}
            </p>
          </div>
        </div>
        <div className="order-content">
          <label>Order Ref:</label>
          <p>{order.orderCode}</p>
        </div>
        <div className="order-content">
          <label>Delivery Date:</label>
          <p>{moment(order.deliveryDate).format(DATE_FORMAT_FRONTEND)}</p>
        </div>
        <div className="order-content">
          <label>User Group:</label>
          <p>{order.group?.name || "-"}</p>
        </div>
        <div className="order-content">
          <label>Load:</label>
          <p>{order.load || "-"}</p>
        </div>
        <div className="order-content">
          <label>Label:</label>
          <p>{labels.length > 0 ? labels.join(", ") : "-"}</p>
        </div>
        <div className="order-content">
          <label>Type:</label>
          <p>{order.requiredSkills?.length > 0 ? order.requiredSkills.join(", ") : "-"}</p>
        </div>
        <div className="order-content">
          <label>Note:</label>
          <p>{order.notes || "-"}</p>
        </div>
        <div className="order-content">
          <label>Driver:</label>
          <p>{order.driver.name || "-"}</p>
        </div>
        <div className="order-content">
          <label>Route Plan:</label>
          <p>{order?.routePlan?.name || "-"}</p>
        </div>
      </div>

      {order.routePlanType === "PDP" && (
        <div className="order-info pickup-info">
          <div className="order-info-header">
            <div className="order-id">
              <p>[Pickup] Warehouse</p>
            </div>
          </div>
          <div className="order-content">
            <label>Address:</label>
            <p>{order.pickupAddress}</p>
          </div>
          <Row gutter={24}>
            <Col span={8}>
              <div className="order-content">
                <label>Phone Number:</label>
                <p>{order.pickupPhone || "-"}</p>
              </div>
            </Col>
            <Col span={8}>
              <div className="order-content">
                <label>Time Window:</label>
                <p>{(order.timeStart || "-") + " - " + (order.timeEnd || "-")}</p>
              </div>
            </Col>
            <Col span={8}>
              <div className="order-content">
                <label>Duration:</label>
                <p>{order.pickupDuration || "-"}</p>
              </div>
            </Col>
          </Row>
          <div className="order-content">
            <label>Note:</label>
            <p>{order.pickupNotes || "-"}</p>
          </div>
        </div>
      )}

      <div className="order-info delivery-info">
        <div className="order-info-header">
          <div className="order-id">
            <p>[Delivery] Tracy McDonald</p>
          </div>
        </div>
        <div className="order-content">
          <label>Address:</label>
          <p>{order.deliveryAddress}</p>
        </div>
        <Row gutter={24}>
          <Col span={8}>
            <div className="order-content">
              <label>Phone Number:</label>
              <p>{order.deliveryPhone || "-"}</p>
            </div>
          </Col>
          <Col span={8}>
            <div className="order-content">
              <label>Time Window:</label>
              <p>{(order.deliveryTimeStart || "-") + " - " + (order.deliveryTimeEnd || "-")}</p>
            </div>
          </Col>
          <Col span={8}>
            <div className="order-content">
              <label>Duration:</label>
              <p>{order.deliveryDuration || "-"}</p>
            </div>
          </Col>
        </Row>
        <div className="order-content">
          <label>Note:</label>
          <p>{order.deliveryNotes || "-"}</p>
        </div>
      </div>
      <footer>
        <p>© 2024 Parcelizer Inc All rights reserved.</p>
        <div className="footer-links">
          <a href={process.env.REACT_APP_LANDING_URI + "/terms"}>Terms of Use</a>
          <a href={process.env.REACT_APP_LANDING_URI + "/privacy"}>Privacy Policy</a>
        </div>
      </footer>
    </div>
  );
};

export default withPage(ItemContainer(PublicOrder));
